import { Paragraph, Table, Tag } from '@zillow/constellation-10';
import { FULLSTORY_EXCLUDE_CLASS_NAME } from '@zg-rentals/satellite-components';
import { SatelliteRenterProfileLeadIntentValue } from '@zg-rentals/ts-satellite-client';

const intentLabelDetailsMap: Record<SatelliteRenterProfileLeadIntentValue, { color: 'success'; text: string }> = {
  [SatelliteRenterProfileLeadIntentValue.HIGH_INTENT]: {
    color: 'success',
    text: 'High Intent',
  },
};

type Props = {
  intentLabel?: SatelliteRenterProfileLeadIntentValue | null;
  name: string;
};

export default function NameTableCell({ intentLabel, name }: Props): JSX.Element {
  const intentLabelDetails = intentLabel ? intentLabelDetailsMap[intentLabel] : null;
  const textWrapStyle = name.length > 20 ? 'wrap' : 'nowrap';

  return (
    <Table.HeaderCell css={{ position: 'sticky', left: 0, verticalAlign: 'top' }}>
      <Paragraph
        className={FULLSTORY_EXCLUDE_CLASS_NAME}
        css={{ textTransform: 'capitalize', whiteSpace: textWrapStyle }}
      >
        {name}
      </Paragraph>

      {intentLabelDetails && (
        <Tag
          tone={intentLabelDetails.color}
          size="sm"
          css={{ marginTop: 4, textTransform: 'uppercase', whiteSpace: 'nowrap' }}
        >
          {intentLabelDetails.text}
        </Tag>
      )}
    </Table.HeaderCell>
  );
}
